
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    
  },
})
export default class ComparePanel extends Vue {

  public compareWithAnotherProfile() {
    this.$store.commit('setModal', 'compare');
  }
  
}
